import { createAction } from 'typesafe-actions';

export const clearAdvancedFiltersAction = createAction('filters/clearAdvancedFilters')();
